import { motion } from "framer-motion";

export const InfrastructureNodesBg = () => (
  <div className="absolute inset-0 overflow-hidden">
    <style>{`
      @keyframes dashFlow {
        to { stroke-dashoffset: -20; }
      }
      @keyframes statusBlink {
        0%, 100% { opacity: 0.4; }
        50% { opacity: 1; }
      }
    `}</style>
    <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice">

      {/* ── Central server rack ── */}
      <rect x="38" y="35" width="24" height="30" rx="2.5"
        fill="hsl(239 84% 67% / 0.12)"
        stroke="hsl(239 84% 67% / 0.45)" strokeWidth="0.5"
      />
      {/* Server slots */}
      {[0, 1, 2, 3].map((i) => (
        <g key={`slot-${i}`}>
          <rect x="41" y={38 + i * 6} width="18" height="4" rx="0.8"
            fill="hsl(239 84% 67% / 0.08)"
            stroke="hsl(239 84% 67% / 0.2)" strokeWidth="0.3"
          />
          {/* Drive indicators */}
          <rect x="42.5" y={39 + i * 6} width="5" height="2" rx="0.4" fill="hsl(239 84% 67% / 0.3)" />
          <rect x="48.5" y={39 + i * 6} width="3" height="2" rx="0.4" fill="hsl(239 84% 67% / 0.2)" />
          {/* Status LED */}
          <circle cx="56" cy={40 + i * 6} r="0.7"
            fill="hsl(150 70% 50% / 0.7)"
            style={{ animation: `statusBlink ${1.5 + i * 0.3}s ease-in-out infinite` }}
          />
        </g>
      ))}
      {/* SERVER label */}
      <text x="50" y="34" textAnchor="middle" fontSize="2.2" fill="hsl(239 84% 67% / 0.4)" fontFamily="monospace">SERVER</text>

      {/* ── Database node (top-left) ── */}
      <g>
        <path d={`M38,45 L22,22`} fill="none" stroke="hsl(239 84% 67% / 0.3)" strokeWidth="0.4" strokeDasharray="3 2"
          style={{ animation: "dashFlow 2s linear infinite" }} />
        {/* DB cylinder */}
        <ellipse cx="15" cy="17" rx="8" ry="2.5" fill="hsl(239 84% 67% / 0.1)" stroke="hsl(239 84% 67% / 0.4)" strokeWidth="0.4" />
        <rect x="7" y="17" width="16" height="10" fill="hsl(239 84% 67% / 0.1)" />
        <line x1="7" y1="17" x2="7" y2="27" stroke="hsl(239 84% 67% / 0.4)" strokeWidth="0.4" />
        <line x1="23" y1="17" x2="23" y2="27" stroke="hsl(239 84% 67% / 0.4)" strokeWidth="0.4" />
        <ellipse cx="15" cy="27" rx="8" ry="2.5" fill="hsl(239 84% 67% / 0.1)" stroke="hsl(239 84% 67% / 0.4)" strokeWidth="0.4" />
        {/* DB rows */}
        <line x1="9" y1="21" x2="21" y2="21" stroke="hsl(239 84% 67% / 0.2)" strokeWidth="0.3" />
        <line x1="9" y1="24" x2="21" y2="24" stroke="hsl(239 84% 67% / 0.15)" strokeWidth="0.3" />
        <text x="15" y="14" textAnchor="middle" fontSize="1.8" fill="hsl(239 84% 67% / 0.35)" fontFamily="monospace">DB</text>
      </g>

      {/* ── API gateway (top-right) ── */}
      <g>
        <path d={`M62,45 L78,25`} fill="none" stroke="hsl(150 60% 50% / 0.3)" strokeWidth="0.4" strokeDasharray="3 2"
          style={{ animation: "dashFlow 2.3s linear infinite" }} />
        <rect x="72" y="16" width="16" height="12" rx="2" fill="hsl(150 60% 50% / 0.08)" stroke="hsl(150 60% 50% / 0.4)" strokeWidth="0.4" />
        {/* API curly braces */}
        <text x="80" y="23.5" textAnchor="middle" fontSize="5" fill="hsl(150 60% 50% / 0.45)" fontFamily="monospace">{ }</text>
        <text x="80" y="15" textAnchor="middle" fontSize="1.8" fill="hsl(150 60% 50% / 0.35)" fontFamily="monospace">API</text>
      </g>

      {/* ── Cloud/CDN (bottom-left) ── */}
      <g>
        <path d={`M38,58 L22,75`} fill="none" stroke="hsl(45 90% 60% / 0.3)" strokeWidth="0.4" strokeDasharray="3 2"
          style={{ animation: "dashFlow 1.8s linear infinite" }} />
        {/* Cloud shape */}
        <circle cx="13" cy="74" r="5" fill="hsl(45 90% 60% / 0.06)" stroke="hsl(45 90% 60% / 0.35)" strokeWidth="0.4" />
        <circle cx="19" cy="72" r="6" fill="hsl(45 90% 60% / 0.06)" stroke="hsl(45 90% 60% / 0.35)" strokeWidth="0.4" />
        <circle cx="23" cy="76" r="4.5" fill="hsl(45 90% 60% / 0.06)" stroke="hsl(45 90% 60% / 0.35)" strokeWidth="0.4" />
        <rect x="10" y="74" width="15" height="5" fill="hsl(45 90% 60% / 0.06)" />
        <text x="17" y="70" textAnchor="middle" fontSize="1.8" fill="hsl(45 90% 60% / 0.35)" fontFamily="monospace">CDN</text>
      </g>

      {/* ── Auth/Security (bottom-right) ── */}
      <g>
        <path d={`M62,58 L78,75`} fill="none" stroke="hsl(0 70% 60% / 0.3)" strokeWidth="0.4" strokeDasharray="3 2"
          style={{ animation: "dashFlow 2.5s linear infinite" }} />
        {/* Shield shape */}
        <path d="M80,68 L87,71 L87,78 C87,82 80,86 80,86 C80,86 73,82 73,78 L73,71 Z"
          fill="hsl(0 70% 60% / 0.08)" stroke="hsl(0 70% 60% / 0.4)" strokeWidth="0.4" />
        {/* Lock icon inside shield */}
        <rect x="78" y="75" width="4" height="3.5" rx="0.5" fill="none" stroke="hsl(0 70% 60% / 0.4)" strokeWidth="0.35" />
        <path d="M79,75 L79,73.5 A1,1 0 0,1 81,73.5 L81,75" fill="none" stroke="hsl(0 70% 60% / 0.4)" strokeWidth="0.35" />
        <text x="80" y="67" textAnchor="middle" fontSize="1.8" fill="hsl(0 70% 60% / 0.35)" fontFamily="monospace">AUTH</text>
      </g>

      {/* ── Data flow particles ── */}
      {[
        { path: "M22,22 L38,45", dur: 2.2, delay: 0 },
        { path: "M78,25 L62,45", dur: 2.5, delay: 0.8 },
        { path: "M22,75 L38,58", dur: 2, delay: 1.5 },
        { path: "M78,75 L62,58", dur: 2.8, delay: 0.4 },
      ].map((p, i) => (
        <motion.circle key={`particle-${i}`} r="0.8" fill="hsl(239 84% 67% / 0.7)">
          <animateMotion dur={`${p.dur}s`} repeatCount="indefinite" begin={`${p.delay}s`} path={p.path} />
        </motion.circle>
      ))}

    </svg>
  </div>
);
